<template>
    <div class="tab-menu-wrap">
        <ul class="tab-menu">
            <li class="tab-menu__item active"><a href="">我的健康 (基本) </a></li>
            <li class="tab-menu__item"><a href="">健康升级 (高级)</a></li>
            <li class="tab-menu__item"><a href="">健康CEO (尊享)</a></li>
            <li class="tab-menu__item"><a href="">单独添加的检查项目</a></li>
        </ul>
    </div>
    <div class="tab-menu-con">
        <div class="tab-content active">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">我的健康 (基本)</h3>
                    <p class="depth">该程序旨在预防生活方式疾病，并早期发现20岁以上的成年人的疾病.</p>
                    <div class="table mt20">
                        <table>
                            <caption>我的健康 (检查项目)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: 10%">
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="4">检查项目</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th sope="rowgroup" rowspan="12" class="br" style="border-right: 1px solid #d9d9d9;">基本</th>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>基础检查</span>
                                    </th>
                                    <td class="left">身体测量 (身高和体重), 身体成分分析(BMI), 血压</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>听力测试</span>
                                    </th>
                                    <td class="left">标准纯音测听</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>眼科检查</span>
                                    </th>
                                    <td class="left">视力, 眼压, 眼底照相</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>心肺功能</span>
                                    </th>
                                    <td class="left">肺功能, 胸部X光片, 心电图</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>尿/粪便测试</span>
                                    </th>
                                    <td class="left">微量尿镜检, 粪便隐血</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>血液测试</span>
                                    </th>
                                    <td class="left">
                                        身体测量 (身高和体重),<br>
                                        身体成分分析(BMI),<br>
                                        血压, 听力测试, 标准纯音测听, 眼科检查, 视力, 眼压, 眼底照相,<br>
                                        心肺功能, 肺功能, 胸部X光片, 心电图, 尿/粪便测试, 微量尿镜检,<br>
                                        粪便隐血, 血液测试,<br>
                                        全血细胞计数 (红细胞计数, 白细胞计数, 血红蛋白, 红细胞分布宽度, 血小板, 平均红细胞体积, 平均红细胞血红蛋白含量),<br>
                                        血型(ABO, Rh),<br>
                                        维生素D检测, 糖尿病检测 (血糖, HbA1C),<br>
                                        肝功能检测(总蛋白, 白蛋白, AST, ALT, ALP, r-GTP, TB,DB),<br>
                                        肝炎检测 (甲/乙/丙型),<br>
                                        冠状动脉风险水平 (同型半胱氨酸, CR, CK, 载脂蛋白A1, 载脂蛋白B),<br>
                                        高脂血症筛查 (总胆固醇, HDL, LDL, TG, LDH),<br>
                                        甲状腺功能检查(T3, 游离T4, TSH), 肾功能检查(BUN, 肌酐),<br>
                                        电解质检测(钙, 钾, 钠, 氯, 磷, 总二氧化碳), 痛风检测(尿酸),<br>
                                        免疫血清检测 (风湿病：RF, 梅毒：：VDRL), 艾滋病检测 (抗HIV),<br>
                                        胰腺检测(淀粉酶), 肿瘤标志物 [肝脏(AFP), 胃/结肠(CEA),胰腺(CA19-9),<br>
                                        鳞状细胞癌(SCC), 卵巢癌(CA 125, 女性), 前列腺癌(PSA, 男性)]
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>胃癌筛查</span>
                                    </th>
                                    <td class="left">胃镜检查</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>超声检查</span>
                                    </th>
                                    <td class="left">腹部超声检查</td>
                                </tr>
                                <tr>
                                    <th scope="row" colspan="2">
                                        <span>其他检查</span>
                                    </th>
                                    <td class="left">生物学年龄, 运动咨询</td>
                                </tr>
                                <tr>
                                    <th scope="row" rowspan="2" class="br">
                                        <span>女性检查</span>
                                    </th>
                                    <td>30岁以下</td>
                                    <td class="left">宫颈癌细胞筛查, 风疹检测</td>
                                </tr>
                                <tr>
                                    <td>30岁以上</td>
                                    <td class="left">宫颈癌细胞筛查, 乳房X光检查</td>
                                </tr>
                                <tr>
                                    <th sope="rowgroup" rowspan="6" class="br">基础PLUS</th>
                                </tr>
                                <tr>
                                    <td class="bl left" colspan="3">基础检查的程序+骨密度(BMD)分析+动脉硬化筛查+压力测试+A-D项目之一</td>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>A. 低剂量肺CT</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>B. 甲状腺超声</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>C. 低剂量肺CT+甲状腺超声</span>
                                    </th>
                                </tr>
                                <tr>
                                    <th scope="row" class="bl left" colspan="3">
                                        <span>D. 妇科超声和人乳头状瘤病毒(HPV)</span>
                                    </th>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="font-sub mt20">
                        * 我们向有乳腺癌家族史的30岁以下女性推荐一个包括乳房X光检查的套餐
                    </p>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">健康升级 (高级)</h3>
                    <p class="depth">这是一个旨在早期全面检测韩国人常见癌症或血管疾病的方案（可在选择基础或者选择基础PLUS后添加项目).</p>
                    <div class="table mt20">
                        <table>
                            <caption>健康升级 (检查项目)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">检查项目</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="row" class="br">心脏全套</th>
                                    <td class="left">(基础) 超声心动图, 颈动脉超声</td>
                                </tr>
                                <tr>
                                    <td class="left">脑血管全套CT</td>
                                </tr>
                                <tr>
                                    <th scope="row">脑血管全套</th>
                                    <td class="left">脑MRI + 脑MR血管成像, 颈动脉超声</td>
                                </tr>
                                <tr>
                                    <th scope="row">胃肠道癌全套</th>
                                    <td class="left">腹盆腔CT, 结肠镜检查, 清醒镇静 (睡眠) 检查</td>
                                </tr>
                                <tr>
                                    <th scope="row">女性癌症全套</th>
                                    <td class="left">乳腺超声, 妇科超声, 人乳头瘤病毒 (HPV), 女性激素 (LH/FSH/ES/AMH)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <p class="depth bullet03 mt20">这是一个旨在早期全面检测韩国人常见癌症的方案, 如消化系统癌症 (包括胃癌, 结肠癌, 肝癌, 胰腺癌), 肺癌, 甲状腺癌, 女性癌症
                        (乳腺癌, 妇科癌症).</p>
                    <div class="table mt20">
                        <table>
                            <caption>主要癌症 (检查项目)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">检查项目</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="2" scope="rowgroup">主要癌症</th>
                                    <td class="left">
                                        男性: 基础Plus C (低剂量肺CT + 甲状腺超声) + 腹盆腔CT, 清醒镇静 (睡眠) 结肠镜检查<br><br>
                                        女性: 基础Plus C (低剂量肺CT + 甲状腺超声) + 腹盆腔CT, 清醒镇静 (睡眠) 结肠镜检查, 乳腺超声, 妇科超声, 人乳头状瘤病毒(HPV)
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">健康升级 (高级)</h3>
                    <div class="table ">
                        <table>
                            <caption>健康CEO(检查项目)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="2">检查项目</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th scope="rowgroup">紫色套餐</th>
                                    <td class="left">
                                        男性: 基础Plus C (低剂量肺CT + 甲状腺超声) + 腹盆腔CT, 清醒镇静 (睡眠) 结肠镜检查, 颈动脉超声检查, 心脏3DCT, 脑部MRI +
                                        脑MR血管成像<br> <br>
                                        女性: 基础Plus C (低剂量肺CT + 甲状腺超声) + 腹盆腔CT, 清醒镇静 (睡眠) 结肠镜检查, 乳腺超声, 妇科超声, 人乳头瘤病毒(HPV),
                                        颈动脉超声, 心脏3DCT, 脑部MRI + 脑MR血管成像
                                    </td>
                                </tr>
                                <tr>
                                    <th scope="row">Gold</th>
                                    <td class="left">
                                        男性: 健康CEO紫色套餐 + 心脏超声, PET CT + VIP住宿一晚<br> <br>
                                        女性: 健康CEO紫色套餐 + 心脏超声, PET CT + VIP住宿一晚
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
        <div class="tab-content">
            <div class="lang">
                <div class="info">
                    <h3 class="bullet01">单独添加的检查项目</h3>
                    <div class="table">
                        <table>
                            <caption>单独添加的检查项目(检查项目)</caption>
                            <colgroup>
                                <col style="width: 10%">
                                <col style="width: auto">
                                <col style="width: 20%">
                            </colgroup>
                            <thead>
                                <tr>
                                    <th scope="col" colspan="3">检查项目</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <th rowspan="4" scope="row" class="br">内窥镜检查</th>
                                    <td colspan="2" class="left">结肠镜检查</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">清醒镇静（睡眠）胃镜检查</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">清醒镇静（睡眠）结肠镜检查</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">清醒镇静（睡眠）结肠镜检查</td>
                                </tr>
                                <tr>
                                    <th rowspan="13" scope="row" class="br">CT</th>
                                    <td class="left">腹部CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">腹盆腔CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">肝脏CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">胰腺CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">肾CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">脑CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">心脏（冠状动脉3D）CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">心脏钙化(Ca) CT</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">颈椎(C-spine) CT</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">腰椎(L-spine) CT</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">低剂量肺CT</td>
                                </tr>
                                <tr>
                                    <td class="left">肺（高级）CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left" colspan="2">腹部肥胖(FAT) CT</td>
                                </tr>
                                <tr>
                                    <th rowspan="7" scope="row" class="br">MRI/MRA </th>
                                    <td class="left">脑MRI</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">脑血管MRA</td>
                                </tr>
                                <tr>
                                    <td class="left">脑部MRI及MR血管成像</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td class="left">体部MRI</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">颈椎(C-spine) MRI</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">腰椎(L-spine) MRI</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">腰椎和颈椎MRI</td>
                                </tr>
                                <tr>
                                    <th scope="row" class="br">PET-CT</th>
                                    <td class="left">脑部和身体PET-CT</td>
                                    <td class="left">造影增强</td>
                                </tr>
                                <tr>
                                    <th rowspan="6" scope="row" class="br">超声</th>
                                    <td colspan="2" class="left">超声心动图</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">颈动脉超声</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">甲状腺超声</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">前列腺超声</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">乳腺超声</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">妇科超声</td>
                                </tr>
                                <tr>
                                    <th rowspan="9" scope="row" class="br">其他诊断</th>
                                    <td colspan="2" class="left">数字化(3D)乳腺扫描</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">人乳头瘤病毒</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">激素 (女性)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">激素 (男性)</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">骨矿物密度分析</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">压力测试</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">自然杀伤细胞免疫细胞学检查</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">肠道微生物组分析</td>
                                </tr>
                                <tr>
                                    <td colspan="2" class="left">过敏诊断 (血液-食物)</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>


</template>
<script>
export default {

}
</script>